import React from 'react';

import {useMyAccount} from '../../../../data/hooks/sessionHooks';
import ContainedImage from '../../../elements/ContainedImage';
import Link from '../../../elements/Link';
import handleLogout from '../../../../misc/logout';

// TODO: move this to a module scss
const CONTAINER_STYLE = {
        paddingLeft: 75,
        height: 64,
        position: 'relative',
        marginBottom: 7,
    },
    IMAGE_STYLE = {
        position: 'absolute',
        width: 64,
        height: 64,
        top: 0,
        left: 0,
        borderRadius: 32,
    },
    NAME_STYLE = {paddingTop: '5px'},
    LOGOUT_STYLE = {
        marginTop: '8px',
        display: 'inline-block',
        textDecoration: 'underline',
    };

const CurrentUser = props => {
    const user = useMyAccount();

    return (
        <div style={CONTAINER_STYLE}>
            <ContainedImage src={user.image_url} altSrc="img/no_avatar.png" style={IMAGE_STYLE} />

            <h2 style={NAME_STYLE}>
                {user.first_name} {user.last_name}
            </h2>
            <div>{user.email}</div>

            <Link onClick={handleLogout} style={LOGOUT_STYLE}>
                Switch Account
            </Link>
        </div>
    );
};

export default CurrentUser;
